import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["address", "type", "authorizationCode", "customsOffice"];
  static values = { url: String };

  connect() {
    $(this.addressTarget).on("select2:select select2:clear", (event) => {
      const addressId = event.type === "select2:clear" ? null : event.target.value;
      if (addressId) {
        this.populate(addressId);
      } else {
        this.clear();
      }
    });
  }

  populate(addressId) {
    fetch(`${this.urlValue}?address_id=${addressId}`, {
      headers: { Accept: "application/json" },
    })
      .then((response) => response.json())
      .then((data) => {
        $(this.typeTarget)
          .val(data.customs_location_type || "")
          .trigger("change");
        this.authorizationCodeTarget.value = data.customs_authorization_code || "";
        $(this.customsOfficeTarget)
          .val(data.customs_office_address_id || "")
          .trigger("change");
      });
  }

  clear() {
    $(this.typeTarget).val("").trigger("change");
    this.authorizationCodeTarget.value = "";
    $(this.customsOfficeTarget).val("").trigger("change");
  }
}
